import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { editIcon } from '@europrocurement/l2d-icons';
import { FlexyIconButton } from '@europrocurement/flexy-components';

export type DossierFormaliteProcessesHeaderProps = {
    organizationLabel?: string;
    onUpdateOrganization: () => void;
};

const DossierFormaliteProcessesHeader: React.FunctionComponent<DossierFormaliteProcessesHeaderProps> =
    function ({ organizationLabel, onUpdateOrganization }: DossierFormaliteProcessesHeaderProps) {
        const headerSx = {
            display: 'flex',
            alignItems: 'center',
            columnGap: '8px',
            ml: 1,
        };

        const title = (
            <Typography
                variant="l2dbodym"
                sx={{
                    overflow: 'hidden',
                    textWrap: 'nowrap',
                }}
            >
                {organizationLabel ? `Greffe de ${organizationLabel}` : 'Greffe à définir'}
            </Typography>
        );

        const editButton = (
            <FlexyIconButton
                displayTooltip
                icon={editIcon}
                onClick={onUpdateOrganization}
                tooltipOverwriteProps={{
                    title: 'Changer de greffe',
                }}
                iconOverwriteProps={{
                    size: '2xs',
                    sx: {
                        '&:hover': {
                            color: 'primary.main',
                        },
                    },
                }}
            />
        );

        return (
            <Box sx={headerSx}>
                {title}
                {editButton}
            </Box>
        );
    };

export default DossierFormaliteProcessesHeader;
